import { SidenavService } from './../../services/sidenav.service';
import { AppStateProvider } from './../../services/app-state.provider';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';
import { ApiService } from 'src/app/services/api.service';
import { AdminService } from 'src/app/services/admin.service';
import { SecureStorageService } from 'src/app/services/secure-storage.service';
@Component({
  standalone: false,
  selector: 'app-credit-score-cla',
  templateUrl: './credit-score-cla.component.html',
  styleUrls: ['./credit-score-cla.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class CreditScoreCLAComponent implements OnInit {
  meetingNav: { index: string; name: string; link: string }[];
  url: string;
  creditList: any;
  tenantDetails: any = [];
  tenantDetail: any = [];
  searchTerm: string;
  showOrg = false;
  tenantDetailForOrg: any = {};
  token: any;
  page = 1;
  pageSize = 10;
  showPagination = false;
  selectedTenantName: any;
  multiSelecttenant: any = [];
  membersDeepCopy: any;
  companyList: any = [];
  tenant: any;
  AdminId: string;
  output: number;
  totalComplimentaryCreditPoints: number = 0;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private adminService: AdminService,
    private appStateSrv: AppStateProvider,
    private cdr: ChangeDetectorRef,
    private sideNavService: SidenavService,
    private secureStorage: SecureStorageService
  ) { }

  ngOnInit(): void {
    this.getCompaniesList();
    this.getApiauthorizationToken();

    this.meetingNav = [
      {
        index: '6',
        name: 'Credits',
        link: '/credits',
      },
    ];

    // const route = {
    //   index: '5',
    //   name: 'Credits',
    //   link: '/credits',
    // };
    // this.appStateSrv.setSideNavState(route);
    const route = this.sideNavService.routingChunks({ name: 'Credits' });
    this.appStateSrv.setSideNavState(route);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  getApiauthorizationToken() {
    this.token =
      'Bearer' + ' ' + this.secureStorage.getItem(AppConstant.localStorage.token);
    if (this.token != null) {
      this.AdminId = this.secureStorage.getItem(AppConstant.localStorage.claAdminId);
      this.getClaCredit();
      this.getTenantDetails();
    }
  }

  selectEmailid(item) {
    this.selectedTenantName = item.companyName;
    if (item.id !== null)
      if (this.multiSelecttenant.includes(item.id))
        this.multiSelecttenant.splice(
          this.multiSelecttenant.indexOf(item.id),
          1
        );
      else this.multiSelecttenant.push(item.id);
    else this.multiSelecttenant = [];

    if (this.multiSelecttenant.length != 0) {
      if (this.multiSelecttenant.includes('All')) {
        this.tenantDetail = this.membersDeepCopy;
      }
      this.tenantDetail = this.membersDeepCopy.filter((data) => {
        if (this.multiSelecttenant.includes(data.id)) return data;
      });
    } else {
      this.tenantDetail = this.membersDeepCopy;
    }

    if (this.multiSelecttenant.length >= 1)
      this.selectedTenantName = this.tenantDetail.filter(
        (company) => company.id === this.multiSelecttenant[0]
      )[0].companyName;
    else this.selectedTenantName = this.tenantDetail[0].companyName;
    this.cdr.detectChanges();

    this.handlePageChange(1);
  }

  onClickedOutside(e: Event) {
  }
  generateInitials(fullName: string): string {
    if (fullName !== '' && fullName !== null && fullName !== undefined)
      return (
        fullName.split(' ')[0].charAt(0).toUpperCase() +
        '' +
        (fullName.split(' ')[1] === undefined || fullName.split(' ')[1] === null
          ? ''
          : fullName.split(' ')[1].charAt(0).toUpperCase())
      );
    else return '';
  }

  private getClaCredit() {
    this.url = APIs.getclaCredit;
    const header = {
      Authorization: this.token,
    };
    this.apiService.get(this.url, '', header).subscribe(
      (response) => {
        if (response.data == null) {
          this.creditList = {
            allocated: 0,
            spent: 0,
            remaining: 0,
          };
          return;
        }
        this.creditList = response.data;
      },
      (error) => {
        //handle errors here
        // alert(error)
      }
    );
  }

  getCompaniesList() {
    this.adminService.getCompaniesList().subscribe((response) => {
      if (response.length > 0) {
        this.companyList = response;
        const allOpt = {
          id: null,
          companyName: 'All',
        };
        this.companyList.unshift(allOpt);
        this.selectedTenantName = this.companyList[0].companyName;
      }
    });
  }

  handlePageChange(event) {
    this.page = event;
    this.tenant = this.tenantDetail.slice(
      0,
      this.tenantDetail.length < 10
        ? this.tenantDetail.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  private getTenantDetails() {
    const header = {
      Authorization: this.token,
    };
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getTenant + '?locationId=' + locationId;
    this.apiService.get(this.url, '', header).subscribe(
      (tenantResponse) => {
        if (tenantResponse && tenantResponse.data && tenantResponse.isValid) {
          this.tenantDetails = tenantResponse;
          // const allOption = {
          //   id: null,
          //   companyName: 'All'
          // }
          // this.tenantDetails.data.tenants.unshift(allOption);
          this.selectedTenantName = 'All';
          this.membersDeepCopy = JSON.parse(
            JSON.stringify(this.tenantDetails.data.tenants)
          );
          this.tenantDetail = this.membersDeepCopy;
          if (this.tenantDetails) {
            this.handlePageChange(1);
          }
          // this.tenantDetail = this.tenantDetails.data.tenants;
        } else {
          // alert('Error!!' + tenantResponse.errorMsg)
        }
      },
      (error) => {
        //handle errors here
        // alert(error)
      }
    );
  }

  aggregatedTotal(complimentary: number, poolCredit: number) {
    return complimentary + poolCredit;
  }

  getCompanyShortForm(name: string) {
    if (name) {
      return name
        .split(/\s/)
        .reduce((response, word) => (response += word.slice(0, 1)), '');
    }
  }

  searchTenant(value: string, type: string) {
    this.showPagination = false;
    if (value && type === 'select') {
      if (value == 'All') {
        // this.refreshPagination();
        return this.tenantDetail;
      }
      this.tenantDetail = this.tenantDetails.data.tenants;
      this.tenantDetail = this.tenantDetail.filter((response: any) => {
        if (response.id == value) {
          return this.tenantDetail;
        }
      });
    } else {
      if (this.searchTerm.length == 0) {
        // return this.refreshPagination();
      }
      this.tenantDetail = this.tenantDetails.data.tenants;
      return (this.tenantDetail = this.tenantDetail.filter((res) => {
        return res.companyName.toLowerCase().indexOf(this.searchTerm) > -1;
      }));
    }
  }

  getPoints(pointArray: [], type: string, creditPointType: number) {
    let poolCreditPoints = 0;
    let reservedCreditPoints = 0;
    let totalCreditPoints = 0;
    let usedReservedCreditPoints = 0;
    let UsedPoolCreditPoints = 0;

    if (pointArray !== undefined && pointArray.length > 0) {
      pointArray.find((findCredit: any) => {
        if (findCredit.creditPointTypeId === creditPointType) {
          poolCreditPoints = findCredit.poolCreditPoints;
          totalCreditPoints = findCredit.totalCreditPoints;
          reservedCreditPoints = findCredit.reservedCreditPoints;
          usedReservedCreditPoints = findCredit.usedReservedCreditPoints;
          UsedPoolCreditPoints = findCredit.usedPoolCreditPoints;
        }
      });
    }
    if (type == 'total') return reservedCreditPoints + poolCreditPoints;

    return (reservedCreditPoints + poolCreditPoints) - (usedReservedCreditPoints + UsedPoolCreditPoints)

  }



  showOrgSection(tenant: {}) {
    if (
      tenant &&
      Object.keys(tenant).length !== 0 &&
      tenant.constructor === Object
    ) {
      Object.keys(this.tenantDetailForOrg).length = 0;
      this.tenantDetailForOrg = tenant;
      localStorage.setItem(
        AppConstant.localStorage.creditId,
        this.tenantDetailForOrg.id
      );
      localStorage.setItem(
        AppConstant.localStorage.creditCompanyName,
        this.tenantDetailForOrg.companyName
      );
      if (
        this.tenantDetailForOrg.city !== null &&
        this.tenantDetailForOrg.country !== null
      )
        localStorage.setItem(
          AppConstant.localStorage.creditCompanyAddress,
          this.tenantDetailForOrg.city + ', ' + this.tenantDetailForOrg.country
        );
      this.showOrg = true;
    }
    // alert('No Tenant Details available');
    this.router.navigate(['credits/credit-details']);
  }

  refreshCredit(isCredit: boolean) {
    if (!isCredit) {
      this.showOrg = false;
    }
  }
  RequestCreditpoints() {
    this.url = '';
    this.url = APIs.RequestCLACreditPoints;
    AdminId: parseInt(this.AdminId);
    const header = {
      Authorization: this.token,
    };
    this.url = this.url + '?AdminId=' + this.AdminId;

    this.apiService.post(this.url, '', header).subscribe(
      (Response) => {
        if (Response && Response.isValid) {
          //display success Message here
          //alert(Response.SuccessMsg);
          this.appStateSrv.showToast(Response.SuccessMsg);
        } else {
          //handle error values here. check for 'errorMsg'
          // alert(Response.errorMsg);
        }
      },
      (error) => {
        // handle api error here
        // alert(error)
      }
    );
  }
  // refreshPagination() {
  //   if (this.tenantDetails.data.tenants && this.tenantDetails.data.tenants != undefined && this.tenantDetails.data.tenants.length > 0) {
  //     this.showPagination = true;
  //     this.tenantDetail = this.tenantDetails.data.tenants.map(
  //       (tenant: any, i: any) => ({ id: i + 1, ...tenant })).slice(
  //         (this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  //   }
  // }
}
